export default __webpack_public_path__ + "static/media/example-cz.cfff3c18.png";